import { render, staticRenderFns } from "./AdminSlideMenu.vue?vue&type=template&id=9f87cf42&scoped=true&"
import script from "./AdminSlideMenu.vue?vue&type=script&lang=js&"
export * from "./AdminSlideMenu.vue?vue&type=script&lang=js&"
import style0 from "./AdminSlideMenu.vue?vue&type=style&index=0&id=9f87cf42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f87cf42",
  null
  
)

export default component.exports